/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AQ as AQ,
  rec_Bo as Bo,
  rec_CerrarOrden as CerrarOrden,
  rec_Componente__Dolar_95_36 as Componente__Dolar_95_36,
  rec_Componente_gDolar_103_36 as Componente_gDolar_103_36,
  rec_Componente_vDolar_118_36 as Componente_vDolar_118_36,
  rec_DQ as DQ,
  rec_EstadoError as EstadoError,
  rec_EstadoOrden as EstadoOrden,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_MQ as MQ,
  rec_OQ as OQ,
  rec_React as React,
  rec_RepartoPorArea as RepartoPorArea,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_api as api,
  rec_jQ as jQ,
  rec_kQ as kQ,
  rec_zo as zo,
} from "../../runtime/index.jsx";
import { HistorialTransporte } from "./HistorialTransporte.jsx";
export function OrdenesTransporte() {
  let e = Go(),
    [t, n] = (0, React.useState)(() => AQ(7)),
    [r, i] = (0, React.useState)(kQ),
    [a, o] = (0, React.useState)(DQ),
    [s, c] = (0, React.useState)([]),
    [l, u] = (0, React.useState)(!0),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)(null),
    g = (0, React.useCallback)(async () => {
      u(!0);
      try {
        let e = a === DQ ? `` : `&estado=${a}`;
        (c(await api(`/transporte/ordenes?desde=${t}&hasta=${r}${e}`)), p(``));
      } catch (e) {
        p(e.message);
      } finally {
        u(!1);
      }
    }, [t, r, a]);
  (0, React.useEffect)(() => {
    g();
  }, [g]);
  let _ = (0, React.useMemo)(
    () => ({
      gastado: s.reduce((e, t) => e + Number(t.costo || 0), 0),
      penalidades: s.reduce((e, t) => e + Number(t.penalidad || 0), 0),
      sinCerrar: s.filter((e) => e.estado === `PROGRAMADA`).length,
      fueraDePrecio: s.filter((e) => e.costoPersonalizado === !0).length,
    }),
    [s],
  );
  return (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={f} onReintentar={g} />,
        <section
          className={`${Bo} flex flex-wrap items-end gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Desde`,
                <SelectorFecha value={t} onChange={n} max={r} />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Hasta`,
                <SelectorFecha value={r} onChange={i} min={t} />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Estado`,
                <SelectorMultiple
                  value={a}
                  onChange={o}
                  opciones={[
                    {
                      value: DQ,
                      label: `Todas`,
                    },
                    ...Object.entries(OQ).map(([e, t]) => ({
                      value: e,
                      label: t,
                    })),
                  ]}
                />,
              ]}
            />,
          ]}
        />,
        l ? (
          <Componente__Dolar_95_36 />
        ) : f ? null : (
          <JSXRuntime.Fragment
            children={[
              <div
                className={`grid grid-cols-2 gap-3 sm:grid-cols-4`}
                children={[
                  <Componente_gDolar_103_36
                    etiqueta={`Gastado`}
                    valor={MQ(_.gastado)}
                  />,
                  <Componente_gDolar_103_36
                    etiqueta={`Penalidades`}
                    valor={MQ(_.penalidades)}
                  />,
                  <Componente_gDolar_103_36
                    etiqueta={`Sin cerrar`}
                    valor={_.sinCerrar}
                  />,
                  <Componente_gDolar_103_36
                    etiqueta={`Fuera de precio`}
                    valor={_.fueraDePrecio}
                  />,
                ]}
              />,
              s.length === 0 ? (
                <Componente_vDolar_118_36
                  texto={`No hay órdenes en esas fechas.`}
                />
              ) : (
                <ul
                  className={`flex flex-col gap-3`}
                  children={s.map((e) => (
                    <li
                      key={e.id}
                      className={`${Bo} flex flex-col gap-2`}
                      children={[
                        <div
                          className={`flex flex-wrap items-start justify-between gap-2`}
                          children={[
                            <div
                              children={[
                                <p
                                  className={`font-medium text-(--text-h)`}
                                  children={[e.horaSalida, ` · `, e.destino]}
                                />,
                                <p
                                  className={`text-sm text-(--text)`}
                                  children={[
                                    jQ(e.fecha),
                                    ` · `,
                                    e.placa,
                                    ` · `,
                                    e.proveedor || `sin proveedor`,
                                    ` ·`,
                                    ` `,
                                    e.personas,
                                    ` personas`,
                                  ]}
                                />,
                                <p
                                  className={`text-xs text-(--text)`}
                                  children={[e.codigo, e.creadaPor && ` · armada por ${e.creadaPor}`, e.cerradaPor && ` · cerrada por ${e.cerradaPor}`]}
                                />,
                                <HistorialTransporte de={`orden`} id={e.id} />,
                              ]}
                            />,
                            <div
                              className={`flex flex-col items-end gap-1`}
                              children={[
                                <span
                                  className={`rounded-full border border-(--border) px-2 py-0.5 text-xs text-(--text)`}
                                  children={OQ[e.estado] ?? e.estado}
                                />,
                                e.estado === `PROGRAMADA` ? (
                                  <button
                                    type={`button`}
                                    onClick={() => h(e)}
                                    className={zo}
                                    children={`Cerrar`}
                                  />
                                ) : (
                                  <span
                                    className={`text-xs text-(--text)`}
                                    children={[
                                      e.costo != null && `Costo ${MQ(e.costo)}`,
                                      e.penalidad != null &&
                                        ` · Penalidad ${MQ(e.penalidad)}`,
                                    ]}
                                  />
                                ),
                                e.costoPersonalizado && (
                                  <span
                                    title={`Lo acordado era ${MQ(e.tarifaPrecio)}`}
                                    className={`rounded-full border border-(--warning) px-2 py-0.5 text-[10px] text-(--warning)`}
                                    children={`Fuera del precio acordado`}
                                  />
                                ),
                              ]}
                            />,
                          ]}
                        />,
                        <ul
                          className={`flex flex-wrap gap-2 text-xs text-(--text)`}
                          children={(e.solicitudes ?? []).map((e) => (
                            <li
                              key={e.id}
                              title={e.motivo || void 0}
                              className={`rounded-lg border px-2 py-1 ${e.confirmacion === `RECHAZADO` ? `border-(--error) text-(--error) line-through` : e.confirmacion === `LISTO` ? `border-(--success) text-(--success)` : `border-(--border)`}`}
                              children={[
                                e.personas,
                                ` · `,
                                e.area || `sin área`,
                                ` · `,
                                e.solicitante,
                                e.confirmacion === `LISTO` && ` ✓`,
                              ]}
                            />
                          ))}
                        />,
                        <EstadoOrden orden={e} />,
                        <RepartoPorArea orden={e} />,
                        e.observacion && (
                          <p
                            className={`text-sm text-(--text)`}
                            children={e.observacion}
                          />
                        ),
                      ]}
                    />
                  ))}
                />
              ),
            ]}
          />
        ),
        m && (
          <CerrarOrden
            orden={m}
            onClose={() => h(null)}
            onCerrada={() => {
              (h(null), e.ok(`Orden cerrada`), g());
            }}
          />
        ),
      ]}
    />
  );
}
